import React from 'react';
import { Link } from 'react-router-dom';

interface FormattedTextProps {
  text: string;
  className?: string;
}

/**
 * Componente que formatea texto para resaltar hashtags y convertirlos en enlaces
 */
const FormattedText: React.FC<FormattedTextProps> = ({ text, className = '' }) => {
  if (!text) return null;

  // Expresión regular para detectar hashtags
  const hashtagRegex = /(#\w+)/g;
  
  // Dividir el texto en partes (texto normal y hashtags)
  const parts = text.split(hashtagRegex);
  
  return (
    <span className={className}>
      {parts.map((part, index) => {
        // Si la parte coincide con un hashtag
        if (part.match(hashtagRegex)) {
          const hashtag = part.substring(1); // Quitar el # para la URL
          return (
            <Link 
              key={index}
              to={`/hashtag/${hashtag}`}
              className="text-domired-600 dark:text-domired-400 font-semibold hover:underline"
            >
              {part}
            </Link>
          );
        }
        // Si es texto normal
        return <React.Fragment key={index}>{part}</React.Fragment>;
      })}
    </span>
  );
};

export default FormattedText;
